import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function B() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('solar_panel_175w');
    const { locale } = useRouter();
    const cards = new Array(7).fill(1);

    const IMG1_MAP = {
        us: {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717124334266/2_1.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717124465057/2_1_M.jpg',
        },
        eu: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1729058449060/PC.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1729058448770/M.png',
        },
    };
    const IMG1 = ['eu', 'uk', 'de', 'fr', 'es', 'it'].includes(locale) ? IMG1_MAP.eu : IMG1_MAP.us;
    const IMG2_MAP = {
        us: {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717124487881/2_2.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717124499779/2_2_M.jpg',
        },
        // 特色空格
        de: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1729240763296/2_2.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1729240743291/2_2_M.png',
        },
    };
    const IMG2 = ['de', 'fr', 'es'].includes(locale) ? IMG2_MAP.de : IMG2_MAP.us;
    const IMG4_MAP: any = {
        us: {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717124549386/2_4.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717124558525/2_4_M.jpg',
        },
        de: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1729058447127/DE-PC.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1729058446968/DE-M.png',
        },
        fr: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1729058447852/FR-PC.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1729058448560/FR-M.png',
        },
        es: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1729565938787/ES-PC1.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1729565938309/ES-M1.png',
        },
        it: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1729058447657/IT-PC.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1729058448056/IT-M.png',
        },
    };
    const IMG4 = IMG4_MAP[locale] || IMG4_MAP.us;

    const IMGS = [
        IMG1,
        IMG2,
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717124529348/2_3.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717124539318/2_3_M.jpg',
        },
        IMG4,
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717124566092/2_5.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717124573793/2_5_M.jpg',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717124581850/2_6.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717124591582/2_6_M.jpg',
        },
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717124611210/2_7.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717124621235/2_7_M.jpg',
        },
    ];

    return (
        <div className={`sp-175w-B sp-175w-common ${css['sp-175w-B']}`}>
            <ul className="cards">
                {cards?.map((card: any, k: number) => (
                    <li className={`card card-${k + 1}`} key={k}>
                        <div className="inner">
                            <p className="text">
                                {t.rich(`B_text${k + 1}`, {
                                    b: (txt: string) => <span className="b">{txt}</span>,
                                    s: (txt: string) => <span className="s">{txt}</span>,
                                })}
                            </p>
                            <div className="card-img">
                                <EFPicture src={IMGS[k].pc} srcPad={IMGS[k].h5} srcMobile={IMGS[k].h5} alt={t('B_tip')} />
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
            <p className="tip">{t('B_tip')}</p>
        </div>
    );
}
